// Organizations whose admins may open the Allocation Products report, and nothing
// else in Allocation. Hakio staff always get the whole module.
const PRODUCT_REPORT_ORGS = new Set(["marimekko"])

export function canOpenProductReport(orgName: string | undefined, canAdminister: boolean): boolean {
  return canAdminister && orgName !== undefined && PRODUCT_REPORT_ORGS.has(orgName)
}

export function canOpenAllocation(
  orgName: string | undefined,
  permissions: { isStaff: boolean; canAdminister: boolean },
): boolean {
  return permissions.isStaff || canOpenProductReport(orgName, permissions.canAdminister)
}

// Store blocks the Products report lists for an organization even before any store carries them.
const PRODUCT_REPORT_FIXED_BLOCKS: Record<string, string[]> = {
  marimekko: ["1023", "20900", "1060", "20584", "1067", "880"].map((id) => `BLOCK_${id}`),
}

export function fixedProductReportBlockIds(orgName: string | undefined): string[] {
  return (orgName && PRODUCT_REPORT_FIXED_BLOCKS[orgName]) || []
}
